var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      margin: "auto",
      background: "0 0"
    },
    width: 204,
    height: 204,
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    display: "block"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 32.5,
    rx: 3,
    ry: 3.22,
    width: 6,
    height: 7,
    fill: "#1d0e0b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.3513513513513513s",
    begin: "-1.2285012285012284s",
    repeatCount: "indefinite"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 32.5,
    rx: 3,
    ry: 3.22,
    width: 6,
    height: 7,
    fill: "#1d0e0b",
    transform: "rotate(32.727 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.3513513513513513s",
    begin: "-1.1056511056511056s",
    repeatCount: "indefinite"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 32.5,
    rx: 3,
    ry: 3.22,
    width: 6,
    height: 7,
    fill: "#1d0e0b",
    transform: "rotate(65.455 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.3513513513513513s",
    begin: "-0.9828009828009827s",
    repeatCount: "indefinite"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 32.5,
    rx: 3,
    ry: 3.22,
    width: 6,
    height: 7,
    fill: "#1d0e0b",
    transform: "rotate(98.182 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.3513513513513513s",
    begin: "-0.8599508599508598s",
    repeatCount: "indefinite"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 32.5,
    rx: 3,
    ry: 3.22,
    width: 6,
    height: 7,
    fill: "#1d0e0b",
    transform: "rotate(130.91 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.3513513513513513s",
    begin: "-0.7371007371007371s",
    repeatCount: "indefinite"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 32.5,
    rx: 3,
    ry: 3.22,
    width: 6,
    height: 7,
    fill: "#1d0e0b",
    transform: "rotate(163.636 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.3513513513513513s",
    begin: "-0.6142506142506142s",
    repeatCount: "indefinite"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 32.5,
    rx: 3,
    ry: 3.22,
    width: 6,
    height: 7,
    fill: "#1d0e0b",
    transform: "rotate(196.364 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.3513513513513513s",
    begin: "-0.49140049140049136s",
    repeatCount: "indefinite"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 32.5,
    rx: 3,
    ry: 3.22,
    width: 6,
    height: 7,
    fill: "#1d0e0b",
    transform: "rotate(229.09 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.3513513513513513s",
    begin: "-0.36855036855036855s",
    repeatCount: "indefinite"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 32.5,
    rx: 3,
    ry: 3.22,
    width: 6,
    height: 7,
    fill: "#1d0e0b",
    transform: "rotate(261.818 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.3513513513513513s",
    begin: "-0.24570024570024568s",
    repeatCount: "indefinite"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 32.5,
    rx: 3,
    ry: 3.22,
    width: 6,
    height: 7,
    fill: "#1d0e0b",
    transform: "rotate(294.545 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.3513513513513513s",
    begin: "-0.12285012285012284s",
    repeatCount: "indefinite"
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 32.5,
    rx: 3,
    ry: 3.22,
    width: 6,
    height: 7,
    fill: "#1d0e0b",
    transform: "rotate(327.273 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.3513513513513513s",
    begin: "0s",
    repeatCount: "indefinite"
  }))));
}
export default SvgSpinner;